import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux"; 
import "./addUsername.css";
import { updateUserProfile } from "../../actions/auth";

const UsernameAdd = () => {
  // const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userDetails = useSelector((state) => state.user.user);

    // Form state
  const [formData, setFormData] = useState({
    first_name: userDetails?.first_name || "",
    last_name: userDetails?.last_name || "",
    phone: userDetails?.phone || "",
    username: userDetails?.username || "",
    address: userDetails?.address || "",
    city: userDetails?.city || "",
    state: userDetails?.state || "",
    country: userDetails?.country || "",
  });

  const dispatch = useDispatch();
  const [newUsername, setNewUsername] = useState("");
  const [isEdited, setIsEdited] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const closeButtonRef = useRef(null);

  useEffect(() => {
      setNewUsername(userDetails?.username || "");
  }, [userDetails]);

  // Handle Input Change
  const handleChange = (e) => {
    setIsEdited(true);
    setErrorMessage(""); 
    setSuccessMessage("");
    setNewUsername(e.target.value);
  };

  // Handle Form Submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (!isEdited) {
      setErrorMessage("Please enter a new username before submitting.");
      return;
    }

    const newUsernameValue = newUsername.trim();
    if (newUsernameValue === "") {
      setErrorMessage("Username cannot be empty.");
      return;
    }

    if (newUsernameValue === formData.username) {
      setErrorMessage("Username already in use.");
      return;
    }

    const updatedData = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      username: newUsernameValue,
    };
    const userId = userDetails?.id;

    // If first_name or last_name changed, update them
    if (formData.first_name !== userDetails?.first_name) {
      updatedData.first_name = formData.first_name;
    }
    if (formData.last_name !== userDetails?.last_name) {
      updatedData.last_name = formData.last_name;
    }

    try {
      await updateUserProfile(updatedData, userId, setLoading, setSuccessMessage, setErrorMessage, setIsEdited, dispatch);
      setNewUsername("");
      setTimeout(() => {
        closeButtonRef.current?.click();
      }, 2000);
    } catch (error) {
      // console.error(error);
    }
  };

  return (
    <section className="modal fade user-actions-modal" id="addUsernameModal" tabIndex="-1" aria-labelledby="addUsernameModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content pb-5">
          <div className="d-flex justify-content-end p-3">
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeButtonRef}></button>
          </div>
          <div className="modal-body px-5">
            <h4 className="mb-4">Add Username</h4>

            {errorMessage && <p className="text-center error-container">{errorMessage}</p>}
            {successMessage && <p className="text-center success-container">{successMessage}</p>}

            <form onSubmit={handleSubmit}>
              {userDetails?.username && (
                <div className="form-group">
                  <label>Current Username</label>
                  <input type="text" name="username" className="form-control" value={formData.username} readOnly />
                </div>
              )}

              <div className="form-group">
                <label>{formData.username ? "New" : ""} Username</label>
                <input
                  type="text"
                  className="form-control"
                  value={newUsername}
                  onChange={handleChange}
                />
              </div>

              <button className="confirm-usernameBtn mt-4" type="submit" disabled={!isEdited || loading}>
                {loading ? <span className="spinner-border spinner-border-sm"></span> : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UsernameAdd;
